<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_schulte') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ modeName }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult + ' x ' + parameters.difficult }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_order') }}
            span(slot="value") {{ $i18n.tc('trainer.trainer_gameFormSettingValue_' + parameters.mode, 1) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_invertedTable') }}
            span(slot="value") {{ parameters.invertedTable ? $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') : $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_redAndBlack') }} &nbsp;
            span(slot="value") {{ parameters.redAndBlack ? $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') : $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.numOfExamples }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            modeName() {
                return this.parameters.amountOfTables === 1
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_oneTable')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_twoTables')
            }
        }
    }
</script>